module.exports = __webpack_public_path__ + "static/media/cock-crowing.8835738c.png";